// src/api/org/service.js
import { json } from "utils/http/client";

export const FinanceApi = {
  // list all finance by site
  listAllFinancebySite: (data) =>
    json(`/finance/get-all-transactions-of-a-site/`, {
      method: "POST",
      body: data,
    }),
  // list organization-wide transactions
  listTransactionsByOrganization: (orgId, period = "30days") =>
    json(`/org/organization/${orgId}/transactions/?period=${period}`, {
      method: "GET",
    }),

  // list all pending transactions
  listPendingTransactionsBySite: (data) =>
    json(`/finance/get-pending-transactions-of-a-site/`, {
      method: "POST",
      body: data,
    }),

  // get delivery by ID
  getDeliveryById: (id) =>
    json(`/inventory/get-a-delivery/${id}/`, {
      method: "GET",
    }),
};
